import {DEFAULT_STATE} from '../../reducers/fortnite-game/lifetimePlays.reducer';

export const getLifetimePlaysState = (state): typeof DEFAULT_STATE => {
    return state.get('lifetimePlays');
};
